// extracted by mini-css-extract-plugin
export default {"threedotAnimatiion":"RNqi4Q","threedot":"wr_3MB","firstDot":"qzRSKy","secondDot":"oZKmtu","thirdDot":"rAhWAs"};